import { RouteConfig } from "vue-router";

const vacancias: RouteConfig = {
  path: "/vacancias",
  name: "vacancias",
  component: () => import(/* webpackChunkName: "vacancias" */ "@/views/Vacancias.vue"),
};

export default vacancias;
